import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { IoIosMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import Logo from "../../../assets/logo.svg"
import styled from "styled-components";
import LogoImage from "../../../assets/Hlogo.svg";
import HeroPic from "../../../assets/hero.svg";
import FormSession from "./FormSession";
import Footer from "../../../components/footer/Footer";
// import { Container } from "../../../components/navbar/Nav.styles"

const ContactSession = () => {
  const [status, setStatus] = useState(false);
  return (
    <>
      <Wrap>
        <SideMessage>
          <div>
            <div className="contact__menu">
              <Link to="/">
                {" "}
                <img src={LogoImage} alt="company_logo" />
              </Link>
              <div className="menu__icon" onClick={() => setStatus(true)}>
                <IoIosMenu size={40} />
              </div>
            </div>
            <h1>We’d love to hear from you.</h1>
            <div>
              <img src={HeroPic} alt="hero-pic" />
            </div>
          </div>
        </SideMessage>
        <div className="contact__form">
          <ContactNav>
            <div>
              <NavLink to="/">Home</NavLink>
              <NavLink to="/about">About Us</NavLink>
              <NavLink to="/product">Our Products</NavLink>
              {/* <NavLink to="/">Media</NavLink> */}
              <NavLink to="/contact">Contact</NavLink>
            </div>
          </ContactNav>
          <BurgerNav show={status}>
            <CustomClose onClick={() => {
              setStatus(false);
            }}>
              <IoMdClose size={30}  />
            </CustomClose>
            <div>
              <BurgerLogo>
                <Link to="/">
                  <img src={Logo} alt="company_logo" />
                </Link>
              </BurgerLogo>
              <NavLink to="/">Home</NavLink>
              <NavLink to="/about">About Us</NavLink>
              <NavLink to="/product">Our Products</NavLink>
              <NavLink to="/contact">Contact</NavLink>
            </div>
          </BurgerNav>
          <h1>Contact Us</h1>
          <FormSession />
        </div>
        <div className="footer__session">
          <Footer />
        </div>
      </Wrap>
    </>
  );
};

export default ContactSession;

export const Wrap = styled.div`
  // height: 100vh;
  // background-color: black;
  display: grid;
  grid-template-columns: 45% 55%;

  img {
    max-width: 100%;
  }
.contact__form h1{
   font-family: Futura;
   font-weight: 100;
   color: #1B20E5;
   font-size: 3rem;
   margin-top: 5.5rem;
   margin-left: 114px;
}
.footer__session{
  display: none;
}
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    .contact__form {
      // border: 5px solid red;
      // display: none;
    }
    .footer__session{
      margin-top: 57px;
      display: block;
    }
  }
  @media screen and (max-width: 579px) {
    .contact__form h1{
      margin-top: 3rem;
       margin-left: 1rem;
      text-align: left:
    }
  }
`;

export const SideMessage = styled.div`
  padding-left: 5rem;
  // max-width: 720px;
  color: ${({ theme }) => theme.colors.text};
  padding-top: 1rem;
  padding-bottom: 37px;

  // border: 3px solid red;
  background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651531019/invest-trust/section_b_fftu3z.svg");

  h1 {
    margin-top: 87px;
    font-size: 3rem;
    line-height: 56px;
    max-width: 70%;
    font-family: "Futura";
  }

  div .menu__icon {
    display: none;
  }

  div:nth-of-type(1) {
    // border: 10px solid orange;
  }
  @media screen and (max-width: 991px) {
    padding-bottom: 6rem;
    div .menu__icon {
      display: inline-block;
      margin-right: 1rem;
    }
    div .contact__menu {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  @media screen and (max-width: 579px) {
    padding-left: 2rem;
    padding-right: 2rem;
    div .menu__icon {
      margin-right: 0rem;
    }
    h1 {
      margin-top: 24px;
      font-size: 2.6rem;
      line-height: 56px;
      max-width: 100%;
    }
  }
`;

export const ContactNav = styled.div`
  margin-top: 2rem;
  padding-right: 5rem;
  display: flex;
  justify-content: flex-end;
  div a {
    margin-right: 2rem;
    color: ${({ theme }) => theme.colors.primary};
  }
  div .active {
    border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
    padding: 8px 0px;
  }
  @media screen and (max-width: 991px) {
    div {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;

export const ContactHeader = styled.div`
  font-family: Futura;
  color: #1B20E5;
  font-size: 3rem,
  margin-top: 5.5rem
  margin-left: 114px;
`;

export const BurgerNav = styled.div`
  display: none;
  @media screen and (max-width: 991px) {
    // border: 10px solid red;
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    background-color: ${(props) =>
      props.mode === "dark" ? "#232323" : "#fff"};
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    box-shadow: 8px 16px 16px hsl(0deg 0% 0% / 0.25);
    border: 3px solid transparent;
    transform: ${(props) =>
      props.show ? "translateX(0)" : "translateX(100%)"};
    transition: transform 0.2s;
    .active {
      // border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
      font-weight: bold;
    }
    div:nth-of-type(2) {
      background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1652353267/invest-trust/blue_Opaque_shield_logo_lgommu.png");
      display: flex;
      flex-direction: column;
      margin-left: 1rem;
      margin-right: 1rem;
    }

    a {
      margin-left: 2rem;
      margin-right: 2rem;
      padding-top: 2.5rem;
      padding-bottom: 2.5rem;
      color: #000;
      font-size: 18px;
      width: 60%;
    }
  }
`;

export const CustomNav = styled.div`
  display: none;
  @media screen and (max-width: 991px) {
    // border: 10px solid red;
    display: inline-block;
    cursor: pointer;
    margin-top: 0.5rem;
  }
`;
export const CustomClose = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 2rem;
  margin-left: 1rem;
  cursor: pointer;
  z-index: 1;
`;
export const BurgerLogo = styled.div`
  transform: translateY(-3.3rem);
  margin-left: -1rem;
`;
